export const localBanners = [
  {
    banner: `${process.env.REACT_APP_CLIENT_URL}/images/banner/banner1.jpg`,
    link: "Visa-Turquie-B1---تأشيرة-تركيا-B1#",
  },
  {
    banner: `${process.env.REACT_APP_CLIENT_URL}/images/banner/banner2.jpg`,
    link: "Visa-Qatar---فيزا-قطر",
  },
  {
    banner: `${process.env.REACT_APP_CLIENT_URL}/images/banner/banner3.jpg`,
    link: "E-visa-l'Arabie-Saoudite---فيزا-سعودية-الكترونية-سياحية",
  },
  {
    banner: `${process.env.REACT_APP_CLIENT_URL}/images/banner/banner4.jpg`,
    link: "E-Visa-Indonesia---فيزا-أندونيسيا-الكترونية-سياحية",
  },
];
